import MarketplacesSettingsStore from './MarketplacesSettingsStore'

export default MarketplacesSettingsStore
